<div class="animated fadeIn trafficDetail">
  <div class="panel-container" id="stuff-to-print">
    <div>
      <ng-template dynamicComponent></ng-template>
    </div>
  </div>
</div>
